import { useTranslation } from "react-i18next";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQ = () => {
  const { t } = useTranslation();
  const faqs = [
    {
      question: t('faq.questions.getStarted.q'),
      answer: t('faq.questions.getStarted.a'),
    },
    {
      question: t('faq.questions.whatAreSignals.q'),
      answer: t('faq.questions.whatAreSignals.a'),
    },
    {
      question: t('faq.questions.howAccess.q'),
      answer: t('faq.questions.howAccess.a'),
    },
    {
      question: t('faq.questions.btcAltcoins.q'),
      answer: t('faq.questions.btcAltcoins.a'),
    },
    {
      question: t('faq.questions.exchanges.q'),
      answer: t('faq.questions.exchanges.a'),
    },
    {
      question: t('faq.questions.successRate.q'),
      answer: t('faq.questions.successRate.a'),
    },
    {
      question: t('faq.questions.experience.q'),
      answer: t('faq.questions.experience.a'),
    },
    {
      question: t('faq.questions.howMany.q'),
      answer: t('faq.questions.howMany.a'),
    },
    {
      question: t('faq.questions.token.q'),
      answer: t('faq.questions.token.a'),
    },
    {
      question: t('faq.questions.autoBot.q'),
      answer: t('faq.questions.autoBot.a'),
    },
    {
      question: t('faq.questions.refund.q'),
      answer: t('faq.questions.refund.a'),
    },
    {
      question: t('faq.questions.cancel.q'),
      answer: t('faq.questions.cancel.a'),
    },
  ];

  return (
    <section className="py-20 bg-secondary/20">
      <div className="container px-4">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12 space-y-4">
            <h2 className="text-4xl md:text-5xl font-bold">
              {t('faq.title')}
            </h2>
            <p className="text-xl text-muted-foreground">
              {t('faq.subtitle')}
            </p>
          </div>

          <Accordion type="single" collapsible className="space-y-4">
            {faqs.map((faq, index) => (
              <AccordionItem 
                key={index} 
                value={`item-${index}`}
                className="bg-card/40 backdrop-blur-xl border border-border rounded-lg px-6"
              >
                <AccordionTrigger className="text-left text-lg font-semibold hover:text-primary">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground leading-relaxed">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
